import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=347203b6&scoped=true&lang=pug"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"
import style0 from "./customers.vue?vue&type=style&index=0&id=347203b6&prod&lang=scss&scoped=true"
import style1 from "./customers.vue?vue&type=style&index=1&id=347203b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347203b6",
  null
  
)

export default component.exports